import React, { useContext } from 'react';
import _ from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import './BackgroundToolbar.css';

const BackgroundToolbar = () => {
  const dispatch = useDispatch();
  const { activePageRef } = useContext(DesignContext);
  const currentPage = useSelector(state => state.design.pages[activePageRef.current]);
  const colorPickerColor = useSelector(state => state.design.colorPickerColor);
  const sidePanel = useSelector(state => state.design.sidePanel);

  useEffect(() => {
    const bgColor = _.get(currentPage, 'background.color', '#fff');
    dispatch(designActions.changeColorPickerColor(bgColor));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, activePageRef.current]);

  useEffect(() => {
    const bgColor = _.get(currentPage, 'background.color', '#fff');
    if (sidePanel === 'colorPicker' && colorPickerColor !== bgColor)
      dispatch(designActions.changePageBackgroundColor(activePageRef.current, colorPickerColor));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorPickerColor]);

  const onMouseDown = () => {
    const bgColor = _.get(currentPage, 'background.color', '#fff');
    dispatch(designActions.changeColorPickerColor(bgColor));
    dispatch(designActions.setSidePanel('colorPicker'));
  };

  return (
    <div className="colorPalette">
      <span
        className={`color`}
        style={{ backgroundColor: `${_.get(currentPage, 'background.color', '#fff')}` }}
        onMouseDown={onMouseDown}
      ></span>
    </div>
  );
};

export default BackgroundToolbar;
